import React, { useEffect, useState } from 'react'
import JsonData from "../data/data.json";
import { Services } from '../components/services';

import Footer from '../components/footer';
import SlidingBanner from "../components/Banner";


const ServicesPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const banners = [
    {
      id: 1,
      img: "../img/ServicePageSlide/SLIDE1.jpg",
      alt: "Slide 1",
    },
    {
      id: 2,
      img: "../img/ServicePageSlide/SLIDE2.jpg",
      alt: "Slide 2",
    },
    {
      id: 3,
      img: "../img/ServicePageSlide/SLIDE3.jpg",
      alt: "Slide 3",
    },
    {
      id: 3,
      img: "../img/ServicePageSlide/SLIDE4.jpg",
      alt: "Slide 3",
    },
  ];
  return (
    <>

     <SlidingBanner banners={banners} />
    
     <Services  data={landingPageData.works} />
     
     </>
   
  )
}

export default ServicesPage